import SmallLoadingSpinner from '@/components/Common/SmallLoadingSpinner';
import MockConnectionsList from '@/components/Mockups/MockConnectionsList';
import EmptyList from '@/components/Common/EmptyList';
import ConnectionsListItem from './ConnectionsListItem';

// @vue/component
export default {
  name: 'ConnectionsList',
  components: {
    EmptyList,
    ConnectionsListItem,
    MockConnectionsList,
    SmallLoadingSpinner,
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes(['connections/getConnections']);
    },
    connectionsList() {
      return this.$store.getters['connections/connections'].list?.records || [];
    },
  },
};
